// source: session.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var fix_pb = require('./fix_pb.js');
goog.object.extend(proto, fix_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var custom_pb = require('./custom_pb.js');
goog.object.extend(proto, custom_pb);
goog.exportSymbol('proto.Session.ApplVerIDEnum', null, global);
goog.exportSymbol('proto.Session.DefaultApplVerIDEnum', null, global);
goog.exportSymbol('proto.Session.EncryptMethodEnum', null, global);
goog.exportSymbol('proto.Session.Heartbeat', null, global);
goog.exportSymbol('proto.Session.HopGrp', null, global);
goog.exportSymbol('proto.Session.Logon', null, global);
goog.exportSymbol('proto.Session.Logon.EncryptedPasswordMethodUnionCase', null, global);
goog.exportSymbol('proto.Session.Logon.SessionStatusUnionCase', null, global);
goog.exportSymbol('proto.Session.Logout', null, global);
goog.exportSymbol('proto.Session.Logout.SessionStatusUnionCase', null, global);
goog.exportSymbol('proto.Session.MsgTypeEnum', null, global);
goog.exportSymbol('proto.Session.RefApplVerIDEnum', null, global);
goog.exportSymbol('proto.Session.RefMsgTypeEnum', null, global);
goog.exportSymbol('proto.Session.Reject', null, global);
goog.exportSymbol('proto.Session.Reject.SessionRejectReasonUnionCase', null, global);
goog.exportSymbol('proto.Session.ResendRequest', null, global);
goog.exportSymbol('proto.Session.SequenceReset', null, global);
goog.exportSymbol('proto.Session.SessionRejectReasonEnum', null, global);
goog.exportSymbol('proto.Session.SessionStatusEnum', null, global);
goog.exportSymbol('proto.Session.StandardHeader', null, global);
goog.exportSymbol('proto.Session.StandardTrailer', null, global);
goog.exportSymbol('proto.Session.TestRequest', null, global);
goog.exportSymbol('proto.Session.XMLnonFIX', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Session.StandardHeader = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Session.StandardHeader.repeatedFields_, null);
};
goog.inherits(proto.Session.StandardHeader, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Session.StandardHeader.displayName = 'proto.Session.StandardHeader';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Session.StandardTrailer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Session.StandardTrailer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Session.StandardTrailer.displayName = 'proto.Session.StandardTrailer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Session.HopGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Session.HopGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Session.HopGrp.displayName = 'proto.Session.HopGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Session.Heartbeat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Session.Heartbeat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Session.Heartbeat.displayName = 'proto.Session.Heartbeat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Session.TestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Session.TestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Session.TestRequest.displayName = 'proto.Session.TestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Session.ResendRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Session.ResendRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Session.ResendRequest.displayName = 'proto.Session.ResendRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Session.Reject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.Session.Reject.oneofGroups_);
};
goog.inherits(proto.Session.Reject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Session.Reject.displayName = 'proto.Session.Reject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Session.SequenceReset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Session.SequenceReset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Session.SequenceReset.displayName = 'proto.Session.SequenceReset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Session.Logout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.Session.Logout.oneofGroups_);
};
goog.inherits(proto.Session.Logout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Session.Logout.displayName = 'proto.Session.Logout';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Session.Logon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Session.Logon.repeatedFields_, proto.Session.Logon.oneofGroups_);
};
goog.inherits(proto.Session.Logon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Session.Logon.displayName = 'proto.Session.Logon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Session.XMLnonFIX = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Session.XMLnonFIX, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Session.XMLnonFIX.displayName = 'proto.Session.XMLnonFIX';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Session.StandardHeader.repeatedFields_ = [29];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Session.StandardHeader.prototype.toObject = function(opt_includeInstance) {
  return proto.Session.StandardHeader.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Session.StandardHeader} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.StandardHeader.toObject = function(includeInstance, msg) {
  var f, obj = {
    beginString: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bodyLength: jspb.Message.getFieldWithDefault(msg, 2, 0),
    deliverToCompId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    deliverToSubId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    msgSeqNum: jspb.Message.getFieldWithDefault(msg, 5, 0),
    msgType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    onBehalfOfCompId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    onBehalfOfSubId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    origSendingTime: (f = msg.getOrigSendingTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    possDupFlag: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    possResend: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    secureData: jspb.Message.getFieldWithDefault(msg, 12, ""),
    secureDataLen: jspb.Message.getFieldWithDefault(msg, 13, 0),
    senderCompId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    senderSubId: jspb.Message.getFieldWithDefault(msg, 15, ""),
    sendingTime: (f = msg.getSendingTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    targetCompId: jspb.Message.getFieldWithDefault(msg, 17, ""),
    targetSubId: jspb.Message.getFieldWithDefault(msg, 18, ""),
    deliverToLocationId: jspb.Message.getFieldWithDefault(msg, 19, ""),
    onBehalfOfLocationId: jspb.Message.getFieldWithDefault(msg, 20, ""),
    senderLocationId: jspb.Message.getFieldWithDefault(msg, 21, ""),
    targetLocationId: jspb.Message.getFieldWithDefault(msg, 22, ""),
    lastMsgSeqNumProcessed: jspb.Message.getFieldWithDefault(msg, 23, 0),
    messageEncoding: jspb.Message.getFieldWithDefault(msg, 24, ""),
    xmlData: jspb.Message.getFieldWithDefault(msg, 25, ""),
    xmlDataLen: jspb.Message.getFieldWithDefault(msg, 26, 0),
    applVerId: jspb.Message.getFieldWithDefault(msg, 27, 0),
    cstmApplVerId: jspb.Message.getFieldWithDefault(msg, 28, ""),
    hopGrpList: jspb.Message.toObjectList(msg.getHopGrpList(),
    proto.Session.HopGrp.toObject, includeInstance),
    applExtId: jspb.Message.getFieldWithDefault(msg, 30, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Session.StandardHeader}
 */
proto.Session.StandardHeader.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Session.StandardHeader;
  return proto.Session.StandardHeader.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Session.StandardHeader} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Session.StandardHeader}
 */
proto.Session.StandardHeader.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBeginString(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setBodyLength(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliverToCompId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliverToSubId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setMsgSeqNum(value);
      break;
    case 6:
      var value = /** @type {!proto.Session.MsgTypeEnum} */ (reader.readEnum());
      msg.setMsgType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOnBehalfOfCompId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOnBehalfOfSubId(value);
      break;
    case 9:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOrigSendingTime(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPossDupFlag(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPossResend(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecureData(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setSecureDataLen(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderCompId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderSubId(value);
      break;
    case 16:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetCompId(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetSubId(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliverToLocationId(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setOnBehalfOfLocationId(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderLocationId(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetLocationId(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setLastMsgSeqNumProcessed(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageEncoding(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setXmlData(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setXmlDataLen(value);
      break;
    case 27:
      var value = /** @type {!proto.Session.ApplVerIDEnum} */ (reader.readEnum());
      msg.setApplVerId(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setCstmApplVerId(value);
      break;
    case 29:
      var value = new proto.Session.HopGrp;
      reader.readMessage(value,proto.Session.HopGrp.deserializeBinaryFromReader);
      msg.addHopGrp(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setApplExtId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Session.StandardHeader.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Session.StandardHeader.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Session.StandardHeader} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.StandardHeader.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBeginString();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBodyLength();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getDeliverToCompId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDeliverToSubId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMsgSeqNum();
  if (f !== 0) {
    writer.writeSfixed64(
      5,
      f
    );
  }
  f = message.getMsgType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getOnBehalfOfCompId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOnBehalfOfSubId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOrigSendingTime();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPossDupFlag();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getPossResend();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getSecureData();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSecureDataLen();
  if (f !== 0) {
    writer.writeSfixed64(
      13,
      f
    );
  }
  f = message.getSenderCompId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getSenderSubId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTargetCompId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getTargetSubId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getDeliverToLocationId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getOnBehalfOfLocationId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getSenderLocationId();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getTargetLocationId();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getLastMsgSeqNumProcessed();
  if (f !== 0) {
    writer.writeSfixed64(
      23,
      f
    );
  }
  f = message.getMessageEncoding();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getXmlData();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getXmlDataLen();
  if (f !== 0) {
    writer.writeSfixed64(
      26,
      f
    );
  }
  f = message.getApplVerId();
  if (f !== 0.0) {
    writer.writeEnum(
      27,
      f
    );
  }
  f = message.getCstmApplVerId();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getHopGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      29,
      f,
      proto.Session.HopGrp.serializeBinaryToWriter
    );
  }
  f = message.getApplExtId();
  if (f !== 0) {
    writer.writeSfixed64(
      30,
      f
    );
  }
};


/**
 * optional string begin_string = 1;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getBeginString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setBeginString = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed64 body_length = 2;
 * @return {number}
 */
proto.Session.StandardHeader.prototype.getBodyLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setBodyLength = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string deliver_to_comp_id = 3;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getDeliverToCompId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setDeliverToCompId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string deliver_to_sub_id = 4;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getDeliverToSubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setDeliverToSubId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional sfixed64 msg_seq_num = 5;
 * @return {number}
 */
proto.Session.StandardHeader.prototype.getMsgSeqNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setMsgSeqNum = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional MsgTypeEnum msg_type = 6;
 * @return {!proto.Session.MsgTypeEnum}
 */
proto.Session.StandardHeader.prototype.getMsgType = function() {
  return /** @type {!proto.Session.MsgTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Session.MsgTypeEnum} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setMsgType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string on_behalf_of_comp_id = 7;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getOnBehalfOfCompId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setOnBehalfOfCompId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string on_behalf_of_sub_id = 8;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getOnBehalfOfSubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setOnBehalfOfSubId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional fix.Timestamp orig_sending_time = 9;
 * @return {?proto.fix.Timestamp}
 */
proto.Session.StandardHeader.prototype.getOrigSendingTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 9));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Session.StandardHeader} returns this
*/
proto.Session.StandardHeader.prototype.setOrigSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.clearOrigSendingTime = function() {
  return this.setOrigSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.StandardHeader.prototype.hasOrigSendingTime = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool poss_dup_flag = 10;
 * @return {boolean}
 */
proto.Session.StandardHeader.prototype.getPossDupFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setPossDupFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool poss_resend = 11;
 * @return {boolean}
 */
proto.Session.StandardHeader.prototype.getPossResend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setPossResend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string secure_data = 12;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getSecureData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setSecureData = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional sfixed64 secure_data_len = 13;
 * @return {number}
 */
proto.Session.StandardHeader.prototype.getSecureDataLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setSecureDataLen = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string sender_comp_id = 14;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getSenderCompId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setSenderCompId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string sender_sub_id = 15;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getSenderSubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setSenderSubId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional fix.Timestamp sending_time = 16;
 * @return {?proto.fix.Timestamp}
 */
proto.Session.StandardHeader.prototype.getSendingTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 16));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Session.StandardHeader} returns this
*/
proto.Session.StandardHeader.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.StandardHeader.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string target_comp_id = 17;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getTargetCompId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setTargetCompId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string target_sub_id = 18;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getTargetSubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setTargetSubId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string deliver_to_location_id = 19;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getDeliverToLocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setDeliverToLocationId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string on_behalf_of_location_id = 20;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getOnBehalfOfLocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setOnBehalfOfLocationId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string sender_location_id = 21;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getSenderLocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setSenderLocationId = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string target_location_id = 22;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getTargetLocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setTargetLocationId = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional sfixed64 last_msg_seq_num_processed = 23;
 * @return {number}
 */
proto.Session.StandardHeader.prototype.getLastMsgSeqNumProcessed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setLastMsgSeqNumProcessed = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string message_encoding = 24;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getMessageEncoding = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setMessageEncoding = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string xml_data = 25;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getXmlData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setXmlData = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional sfixed64 xml_data_len = 26;
 * @return {number}
 */
proto.Session.StandardHeader.prototype.getXmlDataLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setXmlDataLen = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional ApplVerIDEnum appl_ver_id = 27;
 * @return {!proto.Session.ApplVerIDEnum}
 */
proto.Session.StandardHeader.prototype.getApplVerId = function() {
  return /** @type {!proto.Session.ApplVerIDEnum} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {!proto.Session.ApplVerIDEnum} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setApplVerId = function(value) {
  return jspb.Message.setProto3EnumField(this, 27, value);
};


/**
 * optional string cstm_appl_ver_id = 28;
 * @return {string}
 */
proto.Session.StandardHeader.prototype.getCstmApplVerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setCstmApplVerId = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * repeated HopGrp hop_grp = 29;
 * @return {!Array<!proto.Session.HopGrp>}
 */
proto.Session.StandardHeader.prototype.getHopGrpList = function() {
  return /** @type{!Array<!proto.Session.HopGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Session.HopGrp, 29));
};


/**
 * @param {!Array<!proto.Session.HopGrp>} value
 * @return {!proto.Session.StandardHeader} returns this
*/
proto.Session.StandardHeader.prototype.setHopGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 29, value);
};


/**
 * @param {!proto.Session.HopGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Session.HopGrp}
 */
proto.Session.StandardHeader.prototype.addHopGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 29, opt_value, proto.Session.HopGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.clearHopGrpList = function() {
  return this.setHopGrpList([]);
};


/**
 * optional sfixed64 appl_ext_id = 30;
 * @return {number}
 */
proto.Session.StandardHeader.prototype.getApplExtId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.StandardHeader} returns this
 */
proto.Session.StandardHeader.prototype.setApplExtId = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Session.StandardTrailer.prototype.toObject = function(opt_includeInstance) {
  return proto.Session.StandardTrailer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Session.StandardTrailer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.StandardTrailer.toObject = function(includeInstance, msg) {
  var f, obj = {
    checkSum: jspb.Message.getFieldWithDefault(msg, 1, ""),
    signature: jspb.Message.getFieldWithDefault(msg, 2, ""),
    signatureLength: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Session.StandardTrailer}
 */
proto.Session.StandardTrailer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Session.StandardTrailer;
  return proto.Session.StandardTrailer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Session.StandardTrailer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Session.StandardTrailer}
 */
proto.Session.StandardTrailer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckSum(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignature(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setSignatureLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Session.StandardTrailer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Session.StandardTrailer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Session.StandardTrailer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.StandardTrailer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCheckSum();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSignature();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSignatureLength();
  if (f !== 0) {
    writer.writeSfixed64(
      3,
      f
    );
  }
};


/**
 * optional string check_sum = 1;
 * @return {string}
 */
proto.Session.StandardTrailer.prototype.getCheckSum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardTrailer} returns this
 */
proto.Session.StandardTrailer.prototype.setCheckSum = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string signature = 2;
 * @return {string}
 */
proto.Session.StandardTrailer.prototype.getSignature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.StandardTrailer} returns this
 */
proto.Session.StandardTrailer.prototype.setSignature = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional sfixed64 signature_length = 3;
 * @return {number}
 */
proto.Session.StandardTrailer.prototype.getSignatureLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.StandardTrailer} returns this
 */
proto.Session.StandardTrailer.prototype.setSignatureLength = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Session.HopGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Session.HopGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Session.HopGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.HopGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    hopCompId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hopRefId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    hopSendingTime: (f = msg.getHopSendingTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Session.HopGrp}
 */
proto.Session.HopGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Session.HopGrp;
  return proto.Session.HopGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Session.HopGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Session.HopGrp}
 */
proto.Session.HopGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHopCompId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setHopRefId(value);
      break;
    case 3:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setHopSendingTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Session.HopGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Session.HopGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Session.HopGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.HopGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHopCompId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHopRefId();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getHopSendingTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string hop_comp_id = 1;
 * @return {string}
 */
proto.Session.HopGrp.prototype.getHopCompId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.HopGrp} returns this
 */
proto.Session.HopGrp.prototype.setHopCompId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed64 hop_ref_id = 2;
 * @return {number}
 */
proto.Session.HopGrp.prototype.getHopRefId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.HopGrp} returns this
 */
proto.Session.HopGrp.prototype.setHopRefId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional fix.Timestamp hop_sending_time = 3;
 * @return {?proto.fix.Timestamp}
 */
proto.Session.HopGrp.prototype.getHopSendingTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 3));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Session.HopGrp} returns this
*/
proto.Session.HopGrp.prototype.setHopSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.HopGrp} returns this
 */
proto.Session.HopGrp.prototype.clearHopSendingTime = function() {
  return this.setHopSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.HopGrp.prototype.hasHopSendingTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Session.Heartbeat.prototype.toObject = function(opt_includeInstance) {
  return proto.Session.Heartbeat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Session.Heartbeat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.Heartbeat.toObject = function(includeInstance, msg) {
  var f, obj = {
    standardHeader: (f = msg.getStandardHeader()) && proto.Session.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && proto.Session.StandardTrailer.toObject(includeInstance, f),
    testReqId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Session.Heartbeat}
 */
proto.Session.Heartbeat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Session.Heartbeat;
  return proto.Session.Heartbeat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Session.Heartbeat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Session.Heartbeat}
 */
proto.Session.Heartbeat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Session.StandardHeader;
      reader.readMessage(value,proto.Session.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 2:
      var value = new proto.Session.StandardTrailer;
      reader.readMessage(value,proto.Session.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTestReqId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Session.Heartbeat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Session.Heartbeat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Session.Heartbeat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.Heartbeat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Session.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.Session.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getTestReqId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional StandardHeader standard_header = 1;
 * @return {?proto.Session.StandardHeader}
 */
proto.Session.Heartbeat.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardHeader, 1));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.Session.Heartbeat} returns this
*/
proto.Session.Heartbeat.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.Heartbeat} returns this
 */
proto.Session.Heartbeat.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Heartbeat.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional StandardTrailer standard_trailer = 2;
 * @return {?proto.Session.StandardTrailer}
 */
proto.Session.Heartbeat.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardTrailer, 2));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.Session.Heartbeat} returns this
*/
proto.Session.Heartbeat.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.Heartbeat} returns this
 */
proto.Session.Heartbeat.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Heartbeat.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string test_req_id = 3;
 * @return {string}
 */
proto.Session.Heartbeat.prototype.getTestReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Heartbeat} returns this
 */
proto.Session.Heartbeat.prototype.setTestReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Session.TestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Session.TestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Session.TestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.TestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    standardHeader: (f = msg.getStandardHeader()) && proto.Session.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && proto.Session.StandardTrailer.toObject(includeInstance, f),
    testReqId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Session.TestRequest}
 */
proto.Session.TestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Session.TestRequest;
  return proto.Session.TestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Session.TestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Session.TestRequest}
 */
proto.Session.TestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Session.StandardHeader;
      reader.readMessage(value,proto.Session.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 2:
      var value = new proto.Session.StandardTrailer;
      reader.readMessage(value,proto.Session.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTestReqId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Session.TestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Session.TestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Session.TestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.TestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Session.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.Session.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getTestReqId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional StandardHeader standard_header = 1;
 * @return {?proto.Session.StandardHeader}
 */
proto.Session.TestRequest.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardHeader, 1));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.Session.TestRequest} returns this
*/
proto.Session.TestRequest.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.TestRequest} returns this
 */
proto.Session.TestRequest.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.TestRequest.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional StandardTrailer standard_trailer = 2;
 * @return {?proto.Session.StandardTrailer}
 */
proto.Session.TestRequest.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardTrailer, 2));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.Session.TestRequest} returns this
*/
proto.Session.TestRequest.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.TestRequest} returns this
 */
proto.Session.TestRequest.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.TestRequest.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string test_req_id = 3;
 * @return {string}
 */
proto.Session.TestRequest.prototype.getTestReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.TestRequest} returns this
 */
proto.Session.TestRequest.prototype.setTestReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Session.ResendRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Session.ResendRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Session.ResendRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.ResendRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    beginSeqNo: jspb.Message.getFieldWithDefault(msg, 1, 0),
    endSeqNo: jspb.Message.getFieldWithDefault(msg, 2, 0),
    standardHeader: (f = msg.getStandardHeader()) && proto.Session.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && proto.Session.StandardTrailer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Session.ResendRequest}
 */
proto.Session.ResendRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Session.ResendRequest;
  return proto.Session.ResendRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Session.ResendRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Session.ResendRequest}
 */
proto.Session.ResendRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setBeginSeqNo(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEndSeqNo(value);
      break;
    case 3:
      var value = new proto.Session.StandardHeader;
      reader.readMessage(value,proto.Session.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 4:
      var value = new proto.Session.StandardTrailer;
      reader.readMessage(value,proto.Session.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Session.ResendRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Session.ResendRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Session.ResendRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.ResendRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBeginSeqNo();
  if (f !== 0) {
    writer.writeSfixed64(
      1,
      f
    );
  }
  f = message.getEndSeqNo();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.Session.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.Session.StandardTrailer.serializeBinaryToWriter
    );
  }
};


/**
 * optional sfixed64 begin_seq_no = 1;
 * @return {number}
 */
proto.Session.ResendRequest.prototype.getBeginSeqNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.ResendRequest} returns this
 */
proto.Session.ResendRequest.prototype.setBeginSeqNo = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sfixed64 end_seq_no = 2;
 * @return {number}
 */
proto.Session.ResendRequest.prototype.getEndSeqNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.ResendRequest} returns this
 */
proto.Session.ResendRequest.prototype.setEndSeqNo = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional StandardHeader standard_header = 3;
 * @return {?proto.Session.StandardHeader}
 */
proto.Session.ResendRequest.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardHeader, 3));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.Session.ResendRequest} returns this
*/
proto.Session.ResendRequest.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.ResendRequest} returns this
 */
proto.Session.ResendRequest.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.ResendRequest.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional StandardTrailer standard_trailer = 4;
 * @return {?proto.Session.StandardTrailer}
 */
proto.Session.ResendRequest.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardTrailer, 4));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.Session.ResendRequest} returns this
*/
proto.Session.ResendRequest.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.ResendRequest} returns this
 */
proto.Session.ResendRequest.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.ResendRequest.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Session.Reject.oneofGroups_ = [[9,10]];

/**
 * @enum {number}
 */
proto.Session.Reject.SessionRejectReasonUnionCase = {
  SESSION_REJECT_REASON_UNION_NOT_SET: 0,
  SESSION_REJECT_REASON: 9,
  SESSION_REJECT_REASON_RESERVED100PLUS: 10
};

/**
 * @return {proto.Session.Reject.SessionRejectReasonUnionCase}
 */
proto.Session.Reject.prototype.getSessionRejectReasonUnionCase = function() {
  return /** @type {proto.Session.Reject.SessionRejectReasonUnionCase} */(jspb.Message.computeOneofCase(this, proto.Session.Reject.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Session.Reject.prototype.toObject = function(opt_includeInstance) {
  return proto.Session.Reject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Session.Reject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.Reject.toObject = function(includeInstance, msg) {
  var f, obj = {
    refSeqNum: jspb.Message.getFieldWithDefault(msg, 1, 0),
    standardHeader: (f = msg.getStandardHeader()) && proto.Session.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && proto.Session.StandardTrailer.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 4, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 5, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 6, 0),
    refMsgType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    refTagId: jspb.Message.getFieldWithDefault(msg, 8, 0),
    sessionRejectReason: jspb.Message.getFieldWithDefault(msg, 9, 0),
    sessionRejectReasonReserved100plus: jspb.Message.getFieldWithDefault(msg, 10, 0),
    refApplExtId: jspb.Message.getFieldWithDefault(msg, 11, 0),
    refApplVerId: jspb.Message.getFieldWithDefault(msg, 12, 0),
    refCstmApplVerId: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Session.Reject}
 */
proto.Session.Reject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Session.Reject;
  return proto.Session.Reject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Session.Reject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Session.Reject}
 */
proto.Session.Reject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setRefSeqNum(value);
      break;
    case 2:
      var value = new proto.Session.StandardHeader;
      reader.readMessage(value,proto.Session.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 3:
      var value = new proto.Session.StandardTrailer;
      reader.readMessage(value,proto.Session.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 7:
      var value = /** @type {!proto.Session.RefMsgTypeEnum} */ (reader.readEnum());
      msg.setRefMsgType(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setRefTagId(value);
      break;
    case 9:
      var value = /** @type {!proto.Session.SessionRejectReasonEnum} */ (reader.readEnum());
      msg.setSessionRejectReason(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSessionRejectReasonReserved100plus(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setRefApplExtId(value);
      break;
    case 12:
      var value = /** @type {!proto.Session.RefApplVerIDEnum} */ (reader.readEnum());
      msg.setRefApplVerId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefCstmApplVerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Session.Reject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Session.Reject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Session.Reject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.Reject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRefSeqNum();
  if (f !== 0) {
    writer.writeSfixed64(
      1,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.Session.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.Session.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      6,
      f
    );
  }
  f = message.getRefMsgType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getRefTagId();
  if (f !== 0) {
    writer.writeSfixed64(
      8,
      f
    );
  }
  f = /** @type {!proto.Session.SessionRejectReasonEnum} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeFixed32(
      10,
      f
    );
  }
  f = message.getRefApplExtId();
  if (f !== 0) {
    writer.writeSfixed64(
      11,
      f
    );
  }
  f = message.getRefApplVerId();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getRefCstmApplVerId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional sfixed64 ref_seq_num = 1;
 * @return {number}
 */
proto.Session.Reject.prototype.getRefSeqNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.setRefSeqNum = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional StandardHeader standard_header = 2;
 * @return {?proto.Session.StandardHeader}
 */
proto.Session.Reject.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardHeader, 2));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.Session.Reject} returns this
*/
proto.Session.Reject.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Reject.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional StandardTrailer standard_trailer = 3;
 * @return {?proto.Session.StandardTrailer}
 */
proto.Session.Reject.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardTrailer, 3));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.Session.Reject} returns this
*/
proto.Session.Reject.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Reject.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string text = 4;
 * @return {string}
 */
proto.Session.Reject.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string encoded_text = 5;
 * @return {string}
 */
proto.Session.Reject.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional sfixed64 encoded_text_len = 6;
 * @return {number}
 */
proto.Session.Reject.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional RefMsgTypeEnum ref_msg_type = 7;
 * @return {!proto.Session.RefMsgTypeEnum}
 */
proto.Session.Reject.prototype.getRefMsgType = function() {
  return /** @type {!proto.Session.RefMsgTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.Session.RefMsgTypeEnum} value
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.setRefMsgType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional sfixed64 ref_tag_id = 8;
 * @return {number}
 */
proto.Session.Reject.prototype.getRefTagId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.setRefTagId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional SessionRejectReasonEnum session_reject_reason = 9;
 * @return {!proto.Session.SessionRejectReasonEnum}
 */
proto.Session.Reject.prototype.getSessionRejectReason = function() {
  return /** @type {!proto.Session.SessionRejectReasonEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.Session.SessionRejectReasonEnum} value
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.setSessionRejectReason = function(value) {
  return jspb.Message.setOneofField(this, 9, proto.Session.Reject.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.clearSessionRejectReason = function() {
  return jspb.Message.setOneofField(this, 9, proto.Session.Reject.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Reject.prototype.hasSessionRejectReason = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional fixed32 session_reject_reason_reserved100plus = 10;
 * @return {number}
 */
proto.Session.Reject.prototype.getSessionRejectReasonReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.setSessionRejectReasonReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.Session.Reject.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.clearSessionRejectReasonReserved100plus = function() {
  return jspb.Message.setOneofField(this, 10, proto.Session.Reject.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Reject.prototype.hasSessionRejectReasonReserved100plus = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional sfixed64 ref_appl_ext_id = 11;
 * @return {number}
 */
proto.Session.Reject.prototype.getRefApplExtId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.setRefApplExtId = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional RefApplVerIDEnum ref_appl_ver_id = 12;
 * @return {!proto.Session.RefApplVerIDEnum}
 */
proto.Session.Reject.prototype.getRefApplVerId = function() {
  return /** @type {!proto.Session.RefApplVerIDEnum} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.Session.RefApplVerIDEnum} value
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.setRefApplVerId = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional string ref_cstm_appl_ver_id = 13;
 * @return {string}
 */
proto.Session.Reject.prototype.getRefCstmApplVerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Reject} returns this
 */
proto.Session.Reject.prototype.setRefCstmApplVerId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Session.SequenceReset.prototype.toObject = function(opt_includeInstance) {
  return proto.Session.SequenceReset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Session.SequenceReset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.SequenceReset.toObject = function(includeInstance, msg) {
  var f, obj = {
    newSeqNo: jspb.Message.getFieldWithDefault(msg, 1, 0),
    standardHeader: (f = msg.getStandardHeader()) && proto.Session.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && proto.Session.StandardTrailer.toObject(includeInstance, f),
    gapFillFlag: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Session.SequenceReset}
 */
proto.Session.SequenceReset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Session.SequenceReset;
  return proto.Session.SequenceReset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Session.SequenceReset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Session.SequenceReset}
 */
proto.Session.SequenceReset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setNewSeqNo(value);
      break;
    case 2:
      var value = new proto.Session.StandardHeader;
      reader.readMessage(value,proto.Session.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 3:
      var value = new proto.Session.StandardTrailer;
      reader.readMessage(value,proto.Session.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGapFillFlag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Session.SequenceReset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Session.SequenceReset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Session.SequenceReset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.SequenceReset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewSeqNo();
  if (f !== 0) {
    writer.writeSfixed64(
      1,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.Session.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.Session.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getGapFillFlag();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional sfixed64 new_seq_no = 1;
 * @return {number}
 */
proto.Session.SequenceReset.prototype.getNewSeqNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.SequenceReset} returns this
 */
proto.Session.SequenceReset.prototype.setNewSeqNo = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional StandardHeader standard_header = 2;
 * @return {?proto.Session.StandardHeader}
 */
proto.Session.SequenceReset.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardHeader, 2));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.Session.SequenceReset} returns this
*/
proto.Session.SequenceReset.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.SequenceReset} returns this
 */
proto.Session.SequenceReset.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.SequenceReset.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional StandardTrailer standard_trailer = 3;
 * @return {?proto.Session.StandardTrailer}
 */
proto.Session.SequenceReset.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardTrailer, 3));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.Session.SequenceReset} returns this
*/
proto.Session.SequenceReset.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.SequenceReset} returns this
 */
proto.Session.SequenceReset.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.SequenceReset.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool gap_fill_flag = 4;
 * @return {boolean}
 */
proto.Session.SequenceReset.prototype.getGapFillFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Session.SequenceReset} returns this
 */
proto.Session.SequenceReset.prototype.setGapFillFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Session.Logout.oneofGroups_ = [[6,7]];

/**
 * @enum {number}
 */
proto.Session.Logout.SessionStatusUnionCase = {
  SESSION_STATUS_UNION_NOT_SET: 0,
  SESSION_STATUS: 6,
  SESSION_STATUS_RESERVED100PLUS: 7
};

/**
 * @return {proto.Session.Logout.SessionStatusUnionCase}
 */
proto.Session.Logout.prototype.getSessionStatusUnionCase = function() {
  return /** @type {proto.Session.Logout.SessionStatusUnionCase} */(jspb.Message.computeOneofCase(this, proto.Session.Logout.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Session.Logout.prototype.toObject = function(opt_includeInstance) {
  return proto.Session.Logout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Session.Logout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.Logout.toObject = function(includeInstance, msg) {
  var f, obj = {
    standardHeader: (f = msg.getStandardHeader()) && proto.Session.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && proto.Session.StandardTrailer.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 3, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 4, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 5, 0),
    sessionStatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
    sessionStatusReserved100plus: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Session.Logout}
 */
proto.Session.Logout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Session.Logout;
  return proto.Session.Logout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Session.Logout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Session.Logout}
 */
proto.Session.Logout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Session.StandardHeader;
      reader.readMessage(value,proto.Session.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 2:
      var value = new proto.Session.StandardTrailer;
      reader.readMessage(value,proto.Session.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 6:
      var value = /** @type {!proto.Session.SessionStatusEnum} */ (reader.readEnum());
      msg.setSessionStatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSessionStatusReserved100plus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Session.Logout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Session.Logout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Session.Logout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.Logout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Session.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.Session.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      5,
      f
    );
  }
  f = /** @type {!proto.Session.SessionStatusEnum} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeFixed32(
      7,
      f
    );
  }
};


/**
 * optional StandardHeader standard_header = 1;
 * @return {?proto.Session.StandardHeader}
 */
proto.Session.Logout.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardHeader, 1));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.Session.Logout} returns this
*/
proto.Session.Logout.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.Logout} returns this
 */
proto.Session.Logout.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Logout.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional StandardTrailer standard_trailer = 2;
 * @return {?proto.Session.StandardTrailer}
 */
proto.Session.Logout.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardTrailer, 2));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.Session.Logout} returns this
*/
proto.Session.Logout.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.Logout} returns this
 */
proto.Session.Logout.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Logout.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string text = 3;
 * @return {string}
 */
proto.Session.Logout.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Logout} returns this
 */
proto.Session.Logout.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string encoded_text = 4;
 * @return {string}
 */
proto.Session.Logout.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Logout} returns this
 */
proto.Session.Logout.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional sfixed64 encoded_text_len = 5;
 * @return {number}
 */
proto.Session.Logout.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logout} returns this
 */
proto.Session.Logout.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional SessionStatusEnum session_status = 6;
 * @return {!proto.Session.SessionStatusEnum}
 */
proto.Session.Logout.prototype.getSessionStatus = function() {
  return /** @type {!proto.Session.SessionStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Session.SessionStatusEnum} value
 * @return {!proto.Session.Logout} returns this
 */
proto.Session.Logout.prototype.setSessionStatus = function(value) {
  return jspb.Message.setOneofField(this, 6, proto.Session.Logout.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Session.Logout} returns this
 */
proto.Session.Logout.prototype.clearSessionStatus = function() {
  return jspb.Message.setOneofField(this, 6, proto.Session.Logout.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Logout.prototype.hasSessionStatus = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional fixed32 session_status_reserved100plus = 7;
 * @return {number}
 */
proto.Session.Logout.prototype.getSessionStatusReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logout} returns this
 */
proto.Session.Logout.prototype.setSessionStatusReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.Session.Logout.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Session.Logout} returns this
 */
proto.Session.Logout.prototype.clearSessionStatusReserved100plus = function() {
  return jspb.Message.setOneofField(this, 7, proto.Session.Logout.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Logout.prototype.hasSessionStatusReserved100plus = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Session.Logon.repeatedFields_ = [13];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Session.Logon.oneofGroups_ = [[23,24],[26,27]];

/**
 * @enum {number}
 */
proto.Session.Logon.EncryptedPasswordMethodUnionCase = {
  ENCRYPTED_PASSWORD_METHOD_UNION_NOT_SET: 0,
  ENCRYPTED_PASSWORD_METHOD: 23,
  ENCRYPTED_PASSWORD_METHOD_RESERVED100PLUS: 24
};

/**
 * @return {proto.Session.Logon.EncryptedPasswordMethodUnionCase}
 */
proto.Session.Logon.prototype.getEncryptedPasswordMethodUnionCase = function() {
  return /** @type {proto.Session.Logon.EncryptedPasswordMethodUnionCase} */(jspb.Message.computeOneofCase(this, proto.Session.Logon.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.Session.Logon.SessionStatusUnionCase = {
  SESSION_STATUS_UNION_NOT_SET: 0,
  SESSION_STATUS: 26,
  SESSION_STATUS_RESERVED100PLUS: 27
};

/**
 * @return {proto.Session.Logon.SessionStatusUnionCase}
 */
proto.Session.Logon.prototype.getSessionStatusUnionCase = function() {
  return /** @type {proto.Session.Logon.SessionStatusUnionCase} */(jspb.Message.computeOneofCase(this, proto.Session.Logon.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Session.Logon.prototype.toObject = function(opt_includeInstance) {
  return proto.Session.Logon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Session.Logon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.Logon.toObject = function(includeInstance, msg) {
  var f, obj = {
    encryptMethod: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rawData: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rawDataLength: jspb.Message.getFieldWithDefault(msg, 3, 0),
    standardHeader: (f = msg.getStandardHeader()) && proto.Session.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && proto.Session.StandardTrailer.toObject(includeInstance, f),
    heartBtInt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    resetSeqNumFlag: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    maxMessageSize: jspb.Message.getFieldWithDefault(msg, 8, 0),
    password: jspb.Message.getFieldWithDefault(msg, 9, ""),
    testMessageIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    username: jspb.Message.getFieldWithDefault(msg, 11, ""),
    defaultApplVerId: jspb.Message.getFieldWithDefault(msg, 12, 0),
    msgTypeGrpList: jspb.Message.toObjectList(msg.getMsgTypeGrpList(),
    common_pb.MsgTypeGrp.toObject, includeInstance),
    nextExpectedMsgSeqNum: jspb.Message.getFieldWithDefault(msg, 14, 0),
    defaultApplExtId: jspb.Message.getFieldWithDefault(msg, 15, 0),
    defaultCstmApplVerId: jspb.Message.getFieldWithDefault(msg, 16, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 17, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 18, 0),
    encryptedNewPassword: jspb.Message.getFieldWithDefault(msg, 19, ""),
    encryptedNewPasswordLen: jspb.Message.getFieldWithDefault(msg, 20, 0),
    encryptedPassword: jspb.Message.getFieldWithDefault(msg, 21, ""),
    encryptedPasswordLen: jspb.Message.getFieldWithDefault(msg, 22, 0),
    encryptedPasswordMethod: jspb.Message.getFieldWithDefault(msg, 23, 0),
    encryptedPasswordMethodReserved100plus: jspb.Message.getFieldWithDefault(msg, 24, 0),
    newPassword: jspb.Message.getFieldWithDefault(msg, 25, ""),
    sessionStatus: jspb.Message.getFieldWithDefault(msg, 26, 0),
    sessionStatusReserved100plus: jspb.Message.getFieldWithDefault(msg, 27, 0),
    text: jspb.Message.getFieldWithDefault(msg, 28, ""),
    logonCustomTags: (f = msg.getLogonCustomTags()) && custom_pb.LogonExtended.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Session.Logon}
 */
proto.Session.Logon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Session.Logon;
  return proto.Session.Logon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Session.Logon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Session.Logon}
 */
proto.Session.Logon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Session.EncryptMethodEnum} */ (reader.readEnum());
      msg.setEncryptMethod(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRawData(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setRawDataLength(value);
      break;
    case 4:
      var value = new proto.Session.StandardHeader;
      reader.readMessage(value,proto.Session.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 5:
      var value = new proto.Session.StandardTrailer;
      reader.readMessage(value,proto.Session.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setHeartBtInt(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResetSeqNumFlag(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setMaxMessageSize(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTestMessageIndicator(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 12:
      var value = /** @type {!proto.Session.DefaultApplVerIDEnum} */ (reader.readEnum());
      msg.setDefaultApplVerId(value);
      break;
    case 13:
      var value = new common_pb.MsgTypeGrp;
      reader.readMessage(value,common_pb.MsgTypeGrp.deserializeBinaryFromReader);
      msg.addMsgTypeGrp(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setNextExpectedMsgSeqNum(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setDefaultApplExtId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultCstmApplVerId(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncryptedNewPassword(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncryptedNewPasswordLen(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncryptedPassword(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncryptedPasswordLen(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncryptedPasswordMethod(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setEncryptedPasswordMethodReserved100plus(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewPassword(value);
      break;
    case 26:
      var value = /** @type {!proto.Session.SessionStatusEnum} */ (reader.readEnum());
      msg.setSessionStatus(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSessionStatusReserved100plus(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 29:
      var value = new custom_pb.LogonExtended;
      reader.readMessage(value,custom_pb.LogonExtended.deserializeBinaryFromReader);
      msg.setLogonCustomTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Session.Logon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Session.Logon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Session.Logon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.Logon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEncryptMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRawData();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRawDataLength();
  if (f !== 0) {
    writer.writeSfixed64(
      3,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.Session.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.Session.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getHeartBtInt();
  if (f !== 0) {
    writer.writeSfixed64(
      6,
      f
    );
  }
  f = message.getResetSeqNumFlag();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getMaxMessageSize();
  if (f !== 0) {
    writer.writeSfixed64(
      8,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTestMessageIndicator();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDefaultApplVerId();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getMsgTypeGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      common_pb.MsgTypeGrp.serializeBinaryToWriter
    );
  }
  f = message.getNextExpectedMsgSeqNum();
  if (f !== 0) {
    writer.writeSfixed64(
      14,
      f
    );
  }
  f = message.getDefaultApplExtId();
  if (f !== 0) {
    writer.writeSfixed64(
      15,
      f
    );
  }
  f = message.getDefaultCstmApplVerId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      18,
      f
    );
  }
  f = message.getEncryptedNewPassword();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getEncryptedNewPasswordLen();
  if (f !== 0) {
    writer.writeSfixed64(
      20,
      f
    );
  }
  f = message.getEncryptedPassword();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getEncryptedPasswordLen();
  if (f !== 0) {
    writer.writeSfixed64(
      22,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeSfixed64(
      23,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeFixed32(
      24,
      f
    );
  }
  f = message.getNewPassword();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = /** @type {!proto.Session.SessionStatusEnum} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeEnum(
      26,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeFixed32(
      27,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getLogonCustomTags();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      custom_pb.LogonExtended.serializeBinaryToWriter
    );
  }
};


/**
 * optional EncryptMethodEnum encrypt_method = 1;
 * @return {!proto.Session.EncryptMethodEnum}
 */
proto.Session.Logon.prototype.getEncryptMethod = function() {
  return /** @type {!proto.Session.EncryptMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Session.EncryptMethodEnum} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setEncryptMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string raw_data = 2;
 * @return {string}
 */
proto.Session.Logon.prototype.getRawData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setRawData = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional sfixed64 raw_data_length = 3;
 * @return {number}
 */
proto.Session.Logon.prototype.getRawDataLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setRawDataLength = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional StandardHeader standard_header = 4;
 * @return {?proto.Session.StandardHeader}
 */
proto.Session.Logon.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardHeader, 4));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.Session.Logon} returns this
*/
proto.Session.Logon.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Logon.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional StandardTrailer standard_trailer = 5;
 * @return {?proto.Session.StandardTrailer}
 */
proto.Session.Logon.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardTrailer, 5));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.Session.Logon} returns this
*/
proto.Session.Logon.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Logon.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional sfixed64 heart_bt_int = 6;
 * @return {number}
 */
proto.Session.Logon.prototype.getHeartBtInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setHeartBtInt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool reset_seq_num_flag = 7;
 * @return {boolean}
 */
proto.Session.Logon.prototype.getResetSeqNumFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setResetSeqNumFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional sfixed64 max_message_size = 8;
 * @return {number}
 */
proto.Session.Logon.prototype.getMaxMessageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setMaxMessageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string password = 9;
 * @return {string}
 */
proto.Session.Logon.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool test_message_indicator = 10;
 * @return {boolean}
 */
proto.Session.Logon.prototype.getTestMessageIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setTestMessageIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string username = 11;
 * @return {string}
 */
proto.Session.Logon.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional DefaultApplVerIDEnum default_appl_ver_id = 12;
 * @return {!proto.Session.DefaultApplVerIDEnum}
 */
proto.Session.Logon.prototype.getDefaultApplVerId = function() {
  return /** @type {!proto.Session.DefaultApplVerIDEnum} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.Session.DefaultApplVerIDEnum} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setDefaultApplVerId = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * repeated Common.MsgTypeGrp msg_type_grp = 13;
 * @return {!Array<!proto.Common.MsgTypeGrp>}
 */
proto.Session.Logon.prototype.getMsgTypeGrpList = function() {
  return /** @type{!Array<!proto.Common.MsgTypeGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.MsgTypeGrp, 13));
};


/**
 * @param {!Array<!proto.Common.MsgTypeGrp>} value
 * @return {!proto.Session.Logon} returns this
*/
proto.Session.Logon.prototype.setMsgTypeGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.Common.MsgTypeGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.MsgTypeGrp}
 */
proto.Session.Logon.prototype.addMsgTypeGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.Common.MsgTypeGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.clearMsgTypeGrpList = function() {
  return this.setMsgTypeGrpList([]);
};


/**
 * optional sfixed64 next_expected_msg_seq_num = 14;
 * @return {number}
 */
proto.Session.Logon.prototype.getNextExpectedMsgSeqNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setNextExpectedMsgSeqNum = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional sfixed64 default_appl_ext_id = 15;
 * @return {number}
 */
proto.Session.Logon.prototype.getDefaultApplExtId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setDefaultApplExtId = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string default_cstm_appl_ver_id = 16;
 * @return {string}
 */
proto.Session.Logon.prototype.getDefaultCstmApplVerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setDefaultCstmApplVerId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string encoded_text = 17;
 * @return {string}
 */
proto.Session.Logon.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional sfixed64 encoded_text_len = 18;
 * @return {number}
 */
proto.Session.Logon.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string encrypted_new_password = 19;
 * @return {string}
 */
proto.Session.Logon.prototype.getEncryptedNewPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setEncryptedNewPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional sfixed64 encrypted_new_password_len = 20;
 * @return {number}
 */
proto.Session.Logon.prototype.getEncryptedNewPasswordLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setEncryptedNewPasswordLen = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string encrypted_password = 21;
 * @return {string}
 */
proto.Session.Logon.prototype.getEncryptedPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setEncryptedPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional sfixed64 encrypted_password_len = 22;
 * @return {number}
 */
proto.Session.Logon.prototype.getEncryptedPasswordLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setEncryptedPasswordLen = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional sfixed64 encrypted_password_method = 23;
 * @return {number}
 */
proto.Session.Logon.prototype.getEncryptedPasswordMethod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setEncryptedPasswordMethod = function(value) {
  return jspb.Message.setOneofField(this, 23, proto.Session.Logon.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.clearEncryptedPasswordMethod = function() {
  return jspb.Message.setOneofField(this, 23, proto.Session.Logon.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Logon.prototype.hasEncryptedPasswordMethod = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional fixed32 encrypted_password_method_reserved100plus = 24;
 * @return {number}
 */
proto.Session.Logon.prototype.getEncryptedPasswordMethodReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setEncryptedPasswordMethodReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 24, proto.Session.Logon.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.clearEncryptedPasswordMethodReserved100plus = function() {
  return jspb.Message.setOneofField(this, 24, proto.Session.Logon.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Logon.prototype.hasEncryptedPasswordMethodReserved100plus = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional string new_password = 25;
 * @return {string}
 */
proto.Session.Logon.prototype.getNewPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setNewPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional SessionStatusEnum session_status = 26;
 * @return {!proto.Session.SessionStatusEnum}
 */
proto.Session.Logon.prototype.getSessionStatus = function() {
  return /** @type {!proto.Session.SessionStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {!proto.Session.SessionStatusEnum} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setSessionStatus = function(value) {
  return jspb.Message.setOneofField(this, 26, proto.Session.Logon.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.clearSessionStatus = function() {
  return jspb.Message.setOneofField(this, 26, proto.Session.Logon.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Logon.prototype.hasSessionStatus = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional fixed32 session_status_reserved100plus = 27;
 * @return {number}
 */
proto.Session.Logon.prototype.getSessionStatusReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setSessionStatusReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 27, proto.Session.Logon.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.clearSessionStatusReserved100plus = function() {
  return jspb.Message.setOneofField(this, 27, proto.Session.Logon.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Logon.prototype.hasSessionStatusReserved100plus = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string text = 28;
 * @return {string}
 */
proto.Session.Logon.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional Custom.LogonExtended logon_custom_tags = 29;
 * @return {?proto.Custom.LogonExtended}
 */
proto.Session.Logon.prototype.getLogonCustomTags = function() {
  return /** @type{?proto.Custom.LogonExtended} */ (
    jspb.Message.getWrapperField(this, custom_pb.LogonExtended, 29));
};


/**
 * @param {?proto.Custom.LogonExtended|undefined} value
 * @return {!proto.Session.Logon} returns this
*/
proto.Session.Logon.prototype.setLogonCustomTags = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.Logon} returns this
 */
proto.Session.Logon.prototype.clearLogonCustomTags = function() {
  return this.setLogonCustomTags(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.Logon.prototype.hasLogonCustomTags = function() {
  return jspb.Message.getField(this, 29) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Session.XMLnonFIX.prototype.toObject = function(opt_includeInstance) {
  return proto.Session.XMLnonFIX.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Session.XMLnonFIX} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.XMLnonFIX.toObject = function(includeInstance, msg) {
  var f, obj = {
    standardHeader: (f = msg.getStandardHeader()) && proto.Session.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && proto.Session.StandardTrailer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Session.XMLnonFIX}
 */
proto.Session.XMLnonFIX.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Session.XMLnonFIX;
  return proto.Session.XMLnonFIX.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Session.XMLnonFIX} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Session.XMLnonFIX}
 */
proto.Session.XMLnonFIX.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Session.StandardHeader;
      reader.readMessage(value,proto.Session.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 2:
      var value = new proto.Session.StandardTrailer;
      reader.readMessage(value,proto.Session.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Session.XMLnonFIX.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Session.XMLnonFIX.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Session.XMLnonFIX} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Session.XMLnonFIX.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Session.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.Session.StandardTrailer.serializeBinaryToWriter
    );
  }
};


/**
 * optional StandardHeader standard_header = 1;
 * @return {?proto.Session.StandardHeader}
 */
proto.Session.XMLnonFIX.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardHeader, 1));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.Session.XMLnonFIX} returns this
*/
proto.Session.XMLnonFIX.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.XMLnonFIX} returns this
 */
proto.Session.XMLnonFIX.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.XMLnonFIX.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional StandardTrailer standard_trailer = 2;
 * @return {?proto.Session.StandardTrailer}
 */
proto.Session.XMLnonFIX.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, proto.Session.StandardTrailer, 2));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.Session.XMLnonFIX} returns this
*/
proto.Session.XMLnonFIX.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Session.XMLnonFIX} returns this
 */
proto.Session.XMLnonFIX.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Session.XMLnonFIX.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.Session.MsgTypeEnum = {
  MSG_TYPE_ADJUSTED_POSITION_REPORT: 0,
  MSG_TYPE_ADVERTISEMENT: 1,
  MSG_TYPE_ALLOCATION_INSTRUCTION: 2,
  MSG_TYPE_ALLOCATION_INSTRUCTION_ACK: 3,
  MSG_TYPE_ALLOCATION_INSTRUCTION_ALERT: 4,
  MSG_TYPE_ALLOCATION_REPORT: 5,
  MSG_TYPE_ALLOCATION_REPORT_ACK: 6,
  MSG_TYPE_APPLICATION_MESSAGE_REPORT: 7,
  MSG_TYPE_APPLICATION_MESSAGE_REQUEST: 8,
  MSG_TYPE_APPLICATION_MESSAGE_REQUEST_ACK: 9,
  MSG_TYPE_ASSIGNMENT_REPORT: 10,
  MSG_TYPE_BID_REQUEST: 11,
  MSG_TYPE_BID_RESPONSE: 12,
  MSG_TYPE_BUSINESS_MESSAGE_REJECT: 13,
  MSG_TYPE_COLLATERAL_ASSIGNMENT: 14,
  MSG_TYPE_COLLATERAL_INQUIRY: 15,
  MSG_TYPE_COLLATERAL_INQUIRY_ACK: 16,
  MSG_TYPE_COLLATERAL_REPORT: 17,
  MSG_TYPE_COLLATERAL_REQUEST: 18,
  MSG_TYPE_COLLATERAL_RESPONSE: 19,
  MSG_TYPE_CONFIRMATION: 20,
  MSG_TYPE_CONFIRMATION_ACK: 21,
  MSG_TYPE_CONFIRMATION_REQUEST: 22,
  MSG_TYPE_CONTRARY_INTENTION_REPORT: 23,
  MSG_TYPE_CROSS_ORDER_CANCEL_REPLACE_REQUEST: 24,
  MSG_TYPE_CROSS_ORDER_CANCEL_REQUEST: 25,
  MSG_TYPE_DERIVATIVE_SECURITY_LIST: 26,
  MSG_TYPE_DERIVATIVE_SECURITY_LIST_REQUEST: 27,
  MSG_TYPE_DERIVATIVE_SECURITY_LIST_UPDATE_REPORT: 28,
  MSG_TYPE_DONT_KNOW_TRADE: 29,
  MSG_TYPE_EMAIL: 30,
  MSG_TYPE_EXECUTION_ACKNOWLEDGEMENT: 31,
  MSG_TYPE_EXECUTION_REPORT: 32,
  MSG_TYPE_HEARTBEAT: 33,
  MSG_TYPE_IOI: 34,
  MSG_TYPE_LIST_CANCEL_REQUEST: 35,
  MSG_TYPE_LIST_EXECUTE: 36,
  MSG_TYPE_LIST_STATUS: 37,
  MSG_TYPE_LIST_STATUS_REQUEST: 38,
  MSG_TYPE_LIST_STRIKE_PRICE: 39,
  MSG_TYPE_LOGON: 40,
  MSG_TYPE_LOGOUT: 41,
  MSG_TYPE_MARKET_DATA_INCREMENTAL_REFRESH: 42,
  MSG_TYPE_MARKET_DATA_REQUEST: 43,
  MSG_TYPE_MARKET_DATA_REQUEST_REJECT: 44,
  MSG_TYPE_MARKET_DATA_SNAPSHOT_FULL_REFRESH: 45,
  MSG_TYPE_MARKET_DEFINITION: 46,
  MSG_TYPE_MARKET_DEFINITION_REQUEST: 47,
  MSG_TYPE_MARKET_DEFINITION_UPDATE_REPORT: 48,
  MSG_TYPE_MASS_QUOTE: 49,
  MSG_TYPE_MASS_QUOTE_ACKNOWLEDGEMENT: 50,
  MSG_TYPE_MULTILEG_ORDER_CANCEL_REPLACE: 51,
  MSG_TYPE_NETWORK_COUNTERPARTY_SYSTEM_STATUS_REQUEST: 52,
  MSG_TYPE_NETWORK_COUNTERPARTY_SYSTEM_STATUS_RESPONSE: 53,
  MSG_TYPE_NEWS: 54,
  MSG_TYPE_NEW_ORDER_CROSS: 55,
  MSG_TYPE_NEW_ORDER_LIST: 56,
  MSG_TYPE_NEW_ORDER_MULTILEG: 57,
  MSG_TYPE_NEW_ORDER_SINGLE: 58,
  MSG_TYPE_ORDER_CANCEL_REJECT: 59,
  MSG_TYPE_ORDER_CANCEL_REPLACE_REQUEST: 60,
  MSG_TYPE_ORDER_CANCEL_REQUEST: 61,
  MSG_TYPE_ORDER_MASS_ACTION_REPORT: 62,
  MSG_TYPE_ORDER_MASS_ACTION_REQUEST: 63,
  MSG_TYPE_ORDER_MASS_CANCEL_REPORT: 64,
  MSG_TYPE_ORDER_MASS_CANCEL_REQUEST: 65,
  MSG_TYPE_ORDER_MASS_STATUS_REQUEST: 66,
  MSG_TYPE_ORDER_STATUS_REQUEST: 67,
  MSG_TYPE_POSITION_MAINTENANCE_REPORT: 68,
  MSG_TYPE_POSITION_MAINTENANCE_REQUEST: 69,
  MSG_TYPE_POSITION_REPORT: 70,
  MSG_TYPE_QUOTE: 71,
  MSG_TYPE_QUOTE_CANCEL: 72,
  MSG_TYPE_QUOTE_REQUEST: 73,
  MSG_TYPE_QUOTE_REQUEST_REJECT: 74,
  MSG_TYPE_QUOTE_RESPONSE: 75,
  MSG_TYPE_QUOTE_STATUS_REPORT: 76,
  MSG_TYPE_QUOTE_STATUS_REQUEST: 77,
  MSG_TYPE_REGISTRATION_INSTRUCTIONS: 78,
  MSG_TYPE_REGISTRATION_INSTRUCTIONS_RESPONSE: 79,
  MSG_TYPE_REJECT: 80,
  MSG_TYPE_REQUEST_FOR_POSITIONS: 81,
  MSG_TYPE_REQUEST_FOR_POSITIONS_ACK: 82,
  MSG_TYPE_RESEND_REQUEST: 83,
  MSG_TYPE_RFQ_REQUEST: 84,
  MSG_TYPE_SECURITY_DEFINITION: 85,
  MSG_TYPE_SECURITY_DEFINITION_REQUEST: 86,
  MSG_TYPE_SECURITY_DEFINITION_UPDATE_REPORT: 87,
  MSG_TYPE_SECURITY_LIST: 88,
  MSG_TYPE_SECURITY_LIST_REQUEST: 89,
  MSG_TYPE_SECURITY_LIST_UPDATE_REPORT: 90,
  MSG_TYPE_SECURITY_STATUS: 91,
  MSG_TYPE_SECURITY_STATUS_REQUEST: 92,
  MSG_TYPE_SECURITY_TYPES: 93,
  MSG_TYPE_SECURITY_TYPE_REQUEST: 94,
  MSG_TYPE_SEQUENCE_RESET: 95,
  MSG_TYPE_SETTLEMENT_INSTRUCTIONS: 96,
  MSG_TYPE_SETTLEMENT_INSTRUCTION_REQUEST: 97,
  MSG_TYPE_SETTLEMENT_OBLIGATION_REPORT: 98,
  MSG_TYPE_STREAM_ASSIGNMENT_REPORT: 99,
  MSG_TYPE_STREAM_ASSIGNMENT_REPORT_ACK: 100,
  MSG_TYPE_STREAM_ASSIGNMENT_REQUEST: 101,
  MSG_TYPE_TEST_REQUEST: 102,
  MSG_TYPE_TRADE_CAPTURE_REPORT: 103,
  MSG_TYPE_TRADE_CAPTURE_REPORT_ACK: 104,
  MSG_TYPE_TRADE_CAPTURE_REPORT_REQUEST: 105,
  MSG_TYPE_TRADE_CAPTURE_REPORT_REQUEST_ACK: 106,
  MSG_TYPE_TRADING_SESSION_LIST: 107,
  MSG_TYPE_TRADING_SESSION_LIST_REQUEST: 108,
  MSG_TYPE_TRADING_SESSION_LIST_UPDATE_REPORT: 109,
  MSG_TYPE_TRADING_SESSION_STATUS: 110,
  MSG_TYPE_TRADING_SESSION_STATUS_REQUEST: 111,
  MSG_TYPE_UNSPECIFIED: 112,
  MSG_TYPE_USER_NOTIFICATION: 113,
  MSG_TYPE_USER_REQUEST: 114,
  MSG_TYPE_USER_RESPONSE: 115,
  MSG_TYPE_XMLNON_FIX: 116
};

/**
 * @enum {number}
 */
proto.Session.ApplVerIDEnum = {
  APPL_VER_ID_UNSPECIFIED: 0,
  APPL_VER_ID_FIX27: 1,
  APPL_VER_ID_FIX30: 2,
  APPL_VER_ID_FIX40: 3,
  APPL_VER_ID_FIX41: 4,
  APPL_VER_ID_FIX42: 5,
  APPL_VER_ID_FIX43: 6,
  APPL_VER_ID_FIX44: 7,
  APPL_VER_ID_FIX50: 8,
  APPL_VER_ID_FIX50SP1: 9,
  APPL_VER_ID_FIX50SP2: 10
};

/**
 * @enum {number}
 */
proto.Session.RefMsgTypeEnum = {
  REF_MSG_TYPE_ADJUSTED_POSITION_REPORT: 0,
  REF_MSG_TYPE_ADVERTISEMENT: 1,
  REF_MSG_TYPE_ALLOCATION_INSTRUCTION: 2,
  REF_MSG_TYPE_ALLOCATION_INSTRUCTION_ACK: 3,
  REF_MSG_TYPE_ALLOCATION_INSTRUCTION_ALERT: 4,
  REF_MSG_TYPE_ALLOCATION_REPORT: 5,
  REF_MSG_TYPE_ALLOCATION_REPORT_ACK: 6,
  REF_MSG_TYPE_APPLICATION_MESSAGE_REPORT: 7,
  REF_MSG_TYPE_APPLICATION_MESSAGE_REQUEST: 8,
  REF_MSG_TYPE_APPLICATION_MESSAGE_REQUEST_ACK: 9,
  REF_MSG_TYPE_ASSIGNMENT_REPORT: 10,
  REF_MSG_TYPE_BID_REQUEST: 11,
  REF_MSG_TYPE_BID_RESPONSE: 12,
  REF_MSG_TYPE_BUSINESS_MESSAGE_REJECT: 13,
  REF_MSG_TYPE_COLLATERAL_ASSIGNMENT: 14,
  REF_MSG_TYPE_COLLATERAL_INQUIRY: 15,
  REF_MSG_TYPE_COLLATERAL_INQUIRY_ACK: 16,
  REF_MSG_TYPE_COLLATERAL_REPORT: 17,
  REF_MSG_TYPE_COLLATERAL_REQUEST: 18,
  REF_MSG_TYPE_COLLATERAL_RESPONSE: 19,
  REF_MSG_TYPE_CONFIRMATION: 20,
  REF_MSG_TYPE_CONFIRMATION_ACK: 21,
  REF_MSG_TYPE_CONFIRMATION_REQUEST: 22,
  REF_MSG_TYPE_CONTRARY_INTENTION_REPORT: 23,
  REF_MSG_TYPE_CROSS_ORDER_CANCEL_REPLACE_REQUEST: 24,
  REF_MSG_TYPE_CROSS_ORDER_CANCEL_REQUEST: 25,
  REF_MSG_TYPE_DERIVATIVE_SECURITY_LIST: 26,
  REF_MSG_TYPE_DERIVATIVE_SECURITY_LIST_REQUEST: 27,
  REF_MSG_TYPE_DERIVATIVE_SECURITY_LIST_UPDATE_REPORT: 28,
  REF_MSG_TYPE_DONT_KNOW_TRADE: 29,
  REF_MSG_TYPE_EMAIL: 30,
  REF_MSG_TYPE_EXECUTION_ACKNOWLEDGEMENT: 31,
  REF_MSG_TYPE_EXECUTION_REPORT: 32,
  REF_MSG_TYPE_HEARTBEAT: 33,
  REF_MSG_TYPE_IOI: 34,
  REF_MSG_TYPE_LIST_CANCEL_REQUEST: 35,
  REF_MSG_TYPE_LIST_EXECUTE: 36,
  REF_MSG_TYPE_LIST_STATUS: 37,
  REF_MSG_TYPE_LIST_STATUS_REQUEST: 38,
  REF_MSG_TYPE_LIST_STRIKE_PRICE: 39,
  REF_MSG_TYPE_LOGON: 40,
  REF_MSG_TYPE_LOGOUT: 41,
  REF_MSG_TYPE_MARKET_DATA_INCREMENTAL_REFRESH: 42,
  REF_MSG_TYPE_MARKET_DATA_REQUEST: 43,
  REF_MSG_TYPE_MARKET_DATA_REQUEST_REJECT: 44,
  REF_MSG_TYPE_MARKET_DATA_SNAPSHOT_FULL_REFRESH: 45,
  REF_MSG_TYPE_MARKET_DEFINITION: 46,
  REF_MSG_TYPE_MARKET_DEFINITION_REQUEST: 47,
  REF_MSG_TYPE_MARKET_DEFINITION_UPDATE_REPORT: 48,
  REF_MSG_TYPE_MASS_QUOTE: 49,
  REF_MSG_TYPE_MASS_QUOTE_ACKNOWLEDGEMENT: 50,
  REF_MSG_TYPE_MULTILEG_ORDER_CANCEL_REPLACE: 51,
  REF_MSG_TYPE_NETWORK_COUNTERPARTY_SYSTEM_STATUS_REQUEST: 52,
  REF_MSG_TYPE_NETWORK_COUNTERPARTY_SYSTEM_STATUS_RESPONSE: 53,
  REF_MSG_TYPE_NEWS: 54,
  REF_MSG_TYPE_NEW_ORDER_CROSS: 55,
  REF_MSG_TYPE_NEW_ORDER_LIST: 56,
  REF_MSG_TYPE_NEW_ORDER_MULTILEG: 57,
  REF_MSG_TYPE_NEW_ORDER_SINGLE: 58,
  REF_MSG_TYPE_ORDER_CANCEL_REJECT: 59,
  REF_MSG_TYPE_ORDER_CANCEL_REPLACE_REQUEST: 60,
  REF_MSG_TYPE_ORDER_CANCEL_REQUEST: 61,
  REF_MSG_TYPE_ORDER_MASS_ACTION_REPORT: 62,
  REF_MSG_TYPE_ORDER_MASS_ACTION_REQUEST: 63,
  REF_MSG_TYPE_ORDER_MASS_CANCEL_REPORT: 64,
  REF_MSG_TYPE_ORDER_MASS_CANCEL_REQUEST: 65,
  REF_MSG_TYPE_ORDER_MASS_STATUS_REQUEST: 66,
  REF_MSG_TYPE_ORDER_STATUS_REQUEST: 67,
  REF_MSG_TYPE_POSITION_MAINTENANCE_REPORT: 68,
  REF_MSG_TYPE_POSITION_MAINTENANCE_REQUEST: 69,
  REF_MSG_TYPE_POSITION_REPORT: 70,
  REF_MSG_TYPE_QUOTE: 71,
  REF_MSG_TYPE_QUOTE_CANCEL: 72,
  REF_MSG_TYPE_QUOTE_REQUEST: 73,
  REF_MSG_TYPE_QUOTE_REQUEST_REJECT: 74,
  REF_MSG_TYPE_QUOTE_RESPONSE: 75,
  REF_MSG_TYPE_QUOTE_STATUS_REPORT: 76,
  REF_MSG_TYPE_QUOTE_STATUS_REQUEST: 77,
  REF_MSG_TYPE_REGISTRATION_INSTRUCTIONS: 78,
  REF_MSG_TYPE_REGISTRATION_INSTRUCTIONS_RESPONSE: 79,
  REF_MSG_TYPE_REJECT: 80,
  REF_MSG_TYPE_REQUEST_FOR_POSITIONS: 81,
  REF_MSG_TYPE_REQUEST_FOR_POSITIONS_ACK: 82,
  REF_MSG_TYPE_RESEND_REQUEST: 83,
  REF_MSG_TYPE_RFQ_REQUEST: 84,
  REF_MSG_TYPE_SECURITY_DEFINITION: 85,
  REF_MSG_TYPE_SECURITY_DEFINITION_REQUEST: 86,
  REF_MSG_TYPE_SECURITY_DEFINITION_UPDATE_REPORT: 87,
  REF_MSG_TYPE_SECURITY_LIST: 88,
  REF_MSG_TYPE_SECURITY_LIST_REQUEST: 89,
  REF_MSG_TYPE_SECURITY_LIST_UPDATE_REPORT: 90,
  REF_MSG_TYPE_SECURITY_STATUS: 91,
  REF_MSG_TYPE_SECURITY_STATUS_REQUEST: 92,
  REF_MSG_TYPE_SECURITY_TYPES: 93,
  REF_MSG_TYPE_SECURITY_TYPE_REQUEST: 94,
  REF_MSG_TYPE_SEQUENCE_RESET: 95,
  REF_MSG_TYPE_SETTLEMENT_INSTRUCTIONS: 96,
  REF_MSG_TYPE_SETTLEMENT_INSTRUCTION_REQUEST: 97,
  REF_MSG_TYPE_SETTLEMENT_OBLIGATION_REPORT: 98,
  REF_MSG_TYPE_STREAM_ASSIGNMENT_REPORT: 99,
  REF_MSG_TYPE_STREAM_ASSIGNMENT_REPORT_ACK: 100,
  REF_MSG_TYPE_STREAM_ASSIGNMENT_REQUEST: 101,
  REF_MSG_TYPE_TEST_REQUEST: 102,
  REF_MSG_TYPE_TRADE_CAPTURE_REPORT: 103,
  REF_MSG_TYPE_TRADE_CAPTURE_REPORT_ACK: 104,
  REF_MSG_TYPE_TRADE_CAPTURE_REPORT_REQUEST: 105,
  REF_MSG_TYPE_TRADE_CAPTURE_REPORT_REQUEST_ACK: 106,
  REF_MSG_TYPE_TRADING_SESSION_LIST: 107,
  REF_MSG_TYPE_TRADING_SESSION_LIST_REQUEST: 108,
  REF_MSG_TYPE_TRADING_SESSION_LIST_UPDATE_REPORT: 109,
  REF_MSG_TYPE_TRADING_SESSION_STATUS: 110,
  REF_MSG_TYPE_TRADING_SESSION_STATUS_REQUEST: 111,
  REF_MSG_TYPE_UNSPECIFIED: 112,
  REF_MSG_TYPE_USER_NOTIFICATION: 113,
  REF_MSG_TYPE_USER_REQUEST: 114,
  REF_MSG_TYPE_USER_RESPONSE: 115,
  REF_MSG_TYPE_XMLNON_FIX: 116
};

/**
 * @enum {number}
 */
proto.Session.RefApplVerIDEnum = {
  REF_APPL_VER_ID_UNSPECIFIED: 0,
  REF_APPL_VER_ID_FIX27: 1,
  REF_APPL_VER_ID_FIX30: 2,
  REF_APPL_VER_ID_FIX40: 3,
  REF_APPL_VER_ID_FIX41: 4,
  REF_APPL_VER_ID_FIX42: 5,
  REF_APPL_VER_ID_FIX43: 6,
  REF_APPL_VER_ID_FIX44: 7,
  REF_APPL_VER_ID_FIX50: 8,
  REF_APPL_VER_ID_FIX50SP1: 9,
  REF_APPL_VER_ID_FIX50SP2: 10
};

/**
 * @enum {number}
 */
proto.Session.SessionRejectReasonEnum = {
  SESSION_REJECT_REASON_UNSPECIFIED: 0,
  SESSION_REJECT_REASON_COMP_ID_PROBLEM: 1,
  SESSION_REJECT_REASON_DECRYPTION_PROBLEM: 2,
  SESSION_REJECT_REASON_INCORRECT_DATA_FORMAT_FOR_VALUE: 3,
  SESSION_REJECT_REASON_INVALID_MSG_TYPE: 4,
  SESSION_REJECT_REASON_INVALID_TAG_NUMBER: 5,
  SESSION_REJECT_REASON_REQUIRED_TAG_MISSING: 6,
  SESSION_REJECT_REASON_SENDING_TIME_ACCURACY_PROBLEM: 7,
  SESSION_REJECT_REASON_SIGNATURE_PROBLEM: 8,
  SESSION_REJECT_REASON_TAG_NOT_DEFINED_FOR_THIS_MESSAGE_TYPE: 9,
  SESSION_REJECT_REASON_TAG_SPECIFIED_WITHOUT_AVALUE: 10,
  SESSION_REJECT_REASON_UNDEFINED_TAG: 11,
  SESSION_REJECT_REASON_VALUE_IS_INCORRECT: 12,
  SESSION_REJECT_REASON_INCORRECT_NUM_IN_GROUP_COUNT_FOR_REPEATING_GROUP: 13,
  SESSION_REJECT_REASON_NON: 14,
  SESSION_REJECT_REASON_REPEATING_GROUP_FIELDS_OUT_OF_ORDER: 15,
  SESSION_REJECT_REASON_TAG_APPEARS_MORE_THAN_ONCE: 16,
  SESSION_REJECT_REASON_TAG_SPECIFIED_OUT_OF_REQUIRED_ORDER: 17,
  SESSION_REJECT_REASON_XML_VALIDATION_ERROR: 18,
  SESSION_REJECT_REASON_OTHER: 19,
  SESSION_REJECT_REASON_INVALID: 20
};

/**
 * @enum {number}
 */
proto.Session.SessionStatusEnum = {
  SESSION_STATUS_UNSPECIFIED: 0,
  SESSION_STATUS_ACCOUNT_LOCKED: 1,
  SESSION_STATUS_INVALID_USERNAME_OR_PASSWORD: 2,
  SESSION_STATUS_LOGONS_ARE_NOT_ALLOWED_AT_THIS_TIME: 3,
  SESSION_STATUS_NEW_SESSION_PASSWORD_DOES_NOT_COMPLY_WITH_POLICY: 4,
  SESSION_STATUS_PASSWORD_EXPIRED: 5,
  SESSION_STATUS_SESSION_ACTIVE: 6,
  SESSION_STATUS_SESSION_LOGOUT_COMPLETE: 7,
  SESSION_STATUS_SESSION_PASSWORD_CHANGED: 8,
  SESSION_STATUS_SESSION_PASSWORD_DUE_TO_EXPIRE: 9
};

/**
 * @enum {number}
 */
proto.Session.EncryptMethodEnum = {
  ENCRYPT_METHOD_UNSPECIFIED: 0,
  ENCRYPT_METHOD_DES: 1,
  ENCRYPT_METHOD_NONE: 2,
  ENCRYPT_METHOD_PKCS: 3,
  ENCRYPT_METHOD_PKCSDES: 4,
  ENCRYPT_METHOD_PGPDES: 5,
  ENCRYPT_METHOD_PEM: 6,
  ENCRYPT_METHOD_PGPDESMD5: 7
};

/**
 * @enum {number}
 */
proto.Session.DefaultApplVerIDEnum = {
  DEFAULT_APPL_VER_ID_UNSPECIFIED: 0,
  DEFAULT_APPL_VER_ID_FIX27: 1,
  DEFAULT_APPL_VER_ID_FIX30: 2,
  DEFAULT_APPL_VER_ID_FIX40: 3,
  DEFAULT_APPL_VER_ID_FIX41: 4,
  DEFAULT_APPL_VER_ID_FIX42: 5,
  DEFAULT_APPL_VER_ID_FIX43: 6,
  DEFAULT_APPL_VER_ID_FIX44: 7,
  DEFAULT_APPL_VER_ID_FIX50: 8,
  DEFAULT_APPL_VER_ID_FIX50SP1: 9,
  DEFAULT_APPL_VER_ID_FIX50SP2: 10
};

goog.object.extend(exports, proto.Session);
